import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExitModalGraph = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 564,
	height: 250,
	viewBox: "0 0 564 250",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M0.5 241H560.5",
			stroke: "#A3C7FA",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0.5 1H560.5",
			stroke: "#A3C7FA",
			strokeOpacity: .5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0.5 49H560.5",
			stroke: "#A3C7FA",
			strokeOpacity: .5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M454.5 1L454.5 241",
			stroke: "#A3C7FA",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeDasharray: "8 8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0.5 97H560.5",
			stroke: "#A3C7FA",
			strokeOpacity: .5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0.5 145H560.5",
			stroke: "#A3C7FA",
			strokeOpacity: .5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0.5 193H560.5",
			stroke: "#A3C7FA",
			strokeOpacity: .5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0.5 174H560.5",
			stroke: "#A3C7FA",
			strokeOpacity: .5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.5 192.337C203.848 203.332 188.131 74 560.5 74",
			stroke: "url(#paint0_linear_8479_4016)",
			strokeWidth: 6,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.5 192C114.694 211.314 560.5 203.39 560.5 203.39",
			stroke: "url(#paint1_linear_8479_4016)",
			strokeWidth: 6,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_8479_4016)",
			children: [
				/* @__PURE__ */ _jsx("rect", {
					x: 442.5,
					y: 65,
					width: 24,
					height: 24,
					rx: 12,
					fill: "#F1F7FF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M454.5 86C459.471 86 463.5 81.9706 463.5 77C463.5 72.0294 459.471 68 454.5 68C449.529 68 445.5 72.0294 445.5 77C445.5 81.9706 449.529 86 454.5 86Z",
					fill: "#87C67D"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M454.5 89C452.127 89 449.807 88.2962 447.833 86.9776C445.86 85.6591 444.322 83.7849 443.413 81.5922C442.505 79.3995 442.268 76.9867 442.731 74.6589C443.194 72.3311 444.336 70.193 446.015 68.5147C447.693 66.8365 449.831 65.6936 452.159 65.2306C454.487 64.7676 456.899 65.0052 459.092 65.9135C461.285 66.8217 463.159 68.3598 464.478 70.3332C465.796 72.3066 466.5 74.6266 466.5 77C466.496 80.1815 465.231 83.2316 462.981 85.4813C460.732 87.7309 457.681 88.9964 454.5 89ZM454.5 66.7143C452.466 66.7143 450.477 67.3175 448.786 68.4477C447.094 69.578 445.776 71.1844 444.997 73.0638C444.219 74.9433 444.015 77.0114 444.412 79.0066C444.809 81.0019 445.788 82.8346 447.227 84.2731C448.665 85.7116 450.498 86.6912 452.493 87.0881C454.489 87.485 456.557 87.2813 458.436 86.5028C460.316 85.7243 461.922 84.4059 463.052 82.7144C464.182 81.023 464.786 79.0343 464.786 77C464.783 74.273 463.698 71.6587 461.77 69.7304C459.841 67.8022 457.227 66.7175 454.5 66.7143Z",
					fill: "#87C67D"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip1_8479_4016)",
			children: [
				/* @__PURE__ */ _jsx("rect", {
					x: 442.5,
					y: 193,
					width: 24,
					height: 24,
					rx: 12,
					fill: "#E9F2FF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M454.5 214C459.471 214 463.5 209.971 463.5 205C463.5 200.029 459.471 196 454.5 196C449.529 196 445.5 200.029 445.5 205C445.5 209.971 449.529 214 454.5 214Z",
					fill: "#FCCE39"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M454.5 217C452.127 217 449.807 216.296 447.833 214.978C445.86 213.659 444.322 211.785 443.413 209.592C442.505 207.399 442.268 204.987 442.731 202.659C443.194 200.331 444.336 198.193 446.015 196.515C447.693 194.836 449.831 193.694 452.159 193.231C454.487 192.768 456.899 193.005 459.092 193.913C461.285 194.822 463.159 196.36 464.478 198.333C465.796 200.307 466.5 202.627 466.5 205C466.496 208.181 465.231 211.232 462.981 213.481C460.732 215.731 457.681 216.996 454.5 217ZM454.5 194.714C452.466 194.714 450.477 195.318 448.786 196.448C447.094 197.578 445.776 199.184 444.997 201.064C444.219 202.943 444.015 205.011 444.412 207.007C444.809 209.002 445.788 210.835 447.227 212.273C448.665 213.712 450.498 214.691 452.493 215.088C454.489 215.485 456.557 215.281 458.436 214.503C460.316 213.724 461.922 212.406 463.052 210.714C464.182 209.023 464.786 207.034 464.786 205C464.783 202.273 463.698 199.659 461.77 197.73C459.841 195.802 457.227 194.717 454.5 194.714Z",
					fill: "#FCCE39"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip2_8479_4016)",
			children: [
				/* @__PURE__ */ _jsx("rect", {
					x: 11.5,
					y: 181,
					width: 24,
					height: 24,
					rx: 12,
					fill: "#EAF3FF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M23.5 202C28.4706 202 32.5 197.971 32.5 193C32.5 188.029 28.4706 184 23.5 184C18.5294 184 14.5 188.029 14.5 193C14.5 197.971 18.5294 202 23.5 202Z",
					fill: "#D84D3D"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M23.5 205C21.1266 205 18.8066 204.296 16.8332 202.978C14.8598 201.659 13.3217 199.785 12.4135 197.592C11.5052 195.399 11.2676 192.987 11.7306 190.659C12.1936 188.331 13.3365 186.193 15.0147 184.515C16.693 182.836 18.8311 181.694 21.1589 181.231C23.4867 180.768 25.8995 181.005 28.0922 181.913C30.2849 182.822 32.1591 184.36 33.4776 186.333C34.7962 188.307 35.5 190.627 35.5 193C35.4964 196.181 34.2309 199.232 31.9813 201.481C29.7316 203.731 26.6815 204.996 23.5 205ZM23.5 182.714C21.4657 182.714 19.477 183.318 17.7856 184.448C16.0941 185.578 14.7757 187.184 13.9972 189.064C13.2187 190.943 13.0151 193.011 13.4119 195.007C13.8088 197.002 14.7884 198.835 16.2269 200.273C17.6654 201.712 19.4981 202.691 21.4934 203.088C23.4886 203.485 25.5567 203.281 27.4362 202.503C29.3156 201.724 30.9221 200.406 32.0523 198.714C33.1825 197.023 33.7857 195.034 33.7857 193C33.7825 190.273 32.6978 187.659 30.7696 185.73C28.8413 183.802 26.227 182.717 23.5 182.714Z",
					fill: "#D84D3D"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_8479_4016",
				x1: 22.5,
				y1: 133.5,
				x2: 560.5,
				y2: 133.5,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", { stopColor: "#D54B36" }),
					/* @__PURE__ */ _jsx("stop", {
						offset: .25,
						stopColor: "#F9A821"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .5,
						stopColor: "#EFFC3F"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .8,
						stopColor: "#87C67D"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_8479_4016",
				x1: 22.5,
				y1: 198.5,
				x2: 560.5,
				y2: 198.5,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", { stopColor: "#D6493E" }),
					/* @__PURE__ */ _jsx("stop", {
						offset: .5,
						stopColor: "#FB982C"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#FCEA3F"
					})
				]
			}),
			/* @__PURE__ */ _jsx("clipPath", {
				id: "clip0_8479_4016",
				children: /* @__PURE__ */ _jsx("rect", {
					x: 442.5,
					y: 65,
					width: 24,
					height: 24,
					rx: 12,
					fill: "white"
				})
			}),
			/* @__PURE__ */ _jsx("clipPath", {
				id: "clip1_8479_4016",
				children: /* @__PURE__ */ _jsx("rect", {
					x: 442.5,
					y: 193,
					width: 24,
					height: 24,
					rx: 12,
					fill: "white"
				})
			}),
			/* @__PURE__ */ _jsx("clipPath", {
				id: "clip2_8479_4016",
				children: /* @__PURE__ */ _jsx("rect", {
					x: 11.5,
					y: 181,
					width: 24,
					height: 24,
					rx: 12,
					fill: "white"
				})
			})
		] })
	]
});
export default SvgExitModalGraph;
